import type { StatusTone } from "@/components/ui";
import type { BookingStatus, HoldStatus } from "./types";

export function bookingStatusTone(status: BookingStatus): StatusTone {
  switch (status) {
    case "confirmed":
    case "completed":
      return "success";
    case "initiated":
    case "pending_confirmation":
    case "pending_payment":
    case "in_progress":
      return "warning";
    case "cancelled":
    case "failed":
    case "disputed":
    case "refunded_partial":
    case "refunded_full":
      return "danger";
    default:
      return "neutral";
  }
}

export function holdStatusTone(status: HoldStatus): StatusTone {
  switch (status) {
    case "converted":
      return "success";
    case "active":
    case "expiring":
      return "warning";
    case "released":
    case "expired":
    case "cancelled":
    case "superseded":
      return "neutral";
    default:
      return "neutral";
  }
}

export function formatLabel(value: string): string {
  return value.replaceAll("_", " ");
}

export function toIsoUtc(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return "";
  const date = new Date(trimmed);
  if (Number.isNaN(date.getTime())) return trimmed;
  return date.toISOString();
}
